<template>
	<div class="mt-3 py-5">
		<b-container>

			<div class="content mb-auto">
				<div class="container-fluid sp-form-container">

					<!--Main layout-->
					<div class="container pl-3 pr-3">

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0">
								<h5 class="ranking_text font-weight-bold p-0 m-0">{{ ranking_name }} 人気ランキング</h5>
							</div>
						</div>

						<div class="row">
							<div class="col-md-12">

								<div class="card mt-3">
									<div class="card-body py-0 m-0 text-muted">
										<div class="row p-0 tab_menu">
											<div @click="changeDisplay(1)" v-bind:class="{ active: display == 1 }" class="org_tab col-2 p-2">
												<span style="font-size: 0.8rem;" class="">総合ピアノ販売</span>
											</div>
											<div @click="changeDisplay(2)" v-bind:class="{ active: display == 2 }" class="org_tab col-2 p-2">
												<span style="font-size: 0.8rem;" class="">国産ピアノ販売</span>
											</div>
											<div @click="changeDisplay(3)" v-bind:class="{ active: display == 3 }" class="org_tab col-2 p-2">
												<span style="font-size: 0.8rem;" class="">輸入ピアノ販売</span>
											</div>
											<div @click="changeDisplay(4)" v-bind:class="{ active: display == 4 }" class="org_tab col-2 p-2" style="min-width: 25%!important;">
												<span style="font-size: 0.8rem;" class="">アップライトピアノ販売</span>
											</div>
											<div @click="changeDisplay(5)" v-bind:class="{ active: display == 5 }" class="org_tab col-2 p-2" style="min-width: 25%!important;">
												<span style="font-size: 0.8rem;" class="">グランドピアノ販売</span>
											</div>
										</div>
										<div class="row tab_contents" v-if="type==1">
											<div class="col-md-12">

												<!-- 総合ピアノ販売 -->
												<div class="" v-show="display == 1">

										          <template v-for="(ranking, index) in allGetTotalRankings">
													<template v-if="index==0">
														<div class="row mt-5 mx-0">
															<div class="col-md-2"></div>
																<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="card col-md-8 pl-0 pr-0 m-0 my-3" style="color: #676460;">
																	<img class="" style="z-index: 1;position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran1_mini.png">
																	<div class="card-body row p-2">
																		<div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
																			<img class="" :src="ranking['image1']" style="width: 80%;height: auto;">
																		</div>
																		<div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
																			<div class="card-body">
																				<div style="position: relative;">
																					<div class="d-flex">
																						<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																						<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																						<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																					</div>
																					<p class="card-text mb-3">{{ ranking['slogan'] }}</p>
																					<p class="card-text mb-3">現在のピアノ販売数　{{ ranking['now_sell_num'] }}台</p>
																					<p class="card-text mb-3">過去に販売したピアノ台数　{{ ranking['sell_num'] }}台</p>
																				</div>
																				<hr>
																				<div>
																					<p><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></p>
																					<p>
																						<span v-if="ranking['about_return']==1">返品可能</span>
																						<span v-if="ranking['about_return']==2">返品不可</span>
																						<span v-if="ranking['about_exchange']==1">　交換可能</span>
																						<span v-if="ranking['about_exchange']==2">　交換不可</span>
																						<span v-if="ranking['whether_pay_installments']==1">　分割払い可能</span>
																						<span v-if="ranking['whether_pay_installments']==2">　分割払い不可</span>
																					</p>
																				</div>
																			</div>
																		</div>
																	</div>
																</a>
															<div class="col-md-2"></div>
														</div>
													</template>
												  </template>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetTotalRankings">
													<template v-if="index==1||index==2||index==3">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<img v-if="index==1" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran2_mini.png">
															<img v-if="index==2" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran3_mini.png">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetTotalRankings">
													<template v-if="index==4||index==5||index==6">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetTotalRankings">
													<template v-if="index==7||index==8||index==9">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												</div>
												
												<!-- 国産ピアノ販売 -->
												<div class="" v-show="display == 2">

										          <template v-for="(ranking, index) in allGetKokusanRankings">
													<template v-if="index==0">
														<div class="row mt-5 mx-0">
															<div class="col-md-2"></div>
																<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="card col-md-8 pl-0 pr-0 m-0 my-3" style="color: #676460;">
																	<img class="" style="z-index: 1;position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran1_mini.png">
																	<div class="card-body row p-2">
																		<div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
																			<img class="" :src="ranking['image1']" style="width: 80%;height: auto;">
																		</div>
																		<div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
																			<div class="card-body">
																				<div style="position: relative;">
																					<div class="d-flex">
																						<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																						<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																						<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																					</div>
																					<p class="card-text mb-3">{{ ranking['slogan'] }}</p>
																					<p class="card-text mb-3">現在のピアノ販売数　{{ ranking['now_sell_num'] }}台</p>
																					<p class="card-text mb-3">過去に販売したピアノ台数　{{ ranking['sell_num'] }}台</p>
																				</div>
																				<hr>
																				<div>
																					<p><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></p>
																					<p>
																						<span v-if="ranking['about_return']==1">返品可能</span>
																						<span v-if="ranking['about_return']==2">返品不可</span>
																						<span v-if="ranking['about_exchange']==1">　交換可能</span>
																						<span v-if="ranking['about_exchange']==2">　交換不可</span>
																						<span v-if="ranking['whether_pay_installments']==1">　分割払い可能</span>
																						<span v-if="ranking['whether_pay_installments']==2">　分割払い不可</span>
																					</p>
																				</div>
																			</div>
																		</div>
																	</div>
																</a>
															<div class="col-md-2"></div>
														</div>
													</template>
												  </template>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetKokusanRankings">
													<template v-if="index==1||index==2||index==3">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<img v-if="index==1" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran2_mini.png">
															<img v-if="index==2" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran3_mini.png">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetKokusanRankings">
													<template v-if="index==4||index==5||index==6">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetKokusanRankings">
													<template v-if="index==7||index==8||index==9">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												</div>

												<!-- 輸入ピアノ販売 -->
												<div class="" v-show="display == 3">

										          <template v-for="(ranking, index) in allGetYunyuRankings">
													<template v-if="index==0">
														<div class="row mt-5 mx-0">
															<div class="col-md-2"></div>
																<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="card col-md-8 pl-0 pr-0 m-0 my-3" style="color: #676460;">
																	<img class="" style="z-index: 1;position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran1_mini.png">
																	<div class="card-body row p-2">
																		<div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
																			<img class="" :src="ranking['image1']" style="width: 80%;height: auto;">
																		</div>
																		<div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
																			<div class="card-body">
																				<div style="position: relative;">
																					<div class="d-flex">
																						<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																						<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																						<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																					</div>
																					<p class="card-text mb-3">{{ ranking['slogan'] }}</p>
																					<p class="card-text mb-3">現在のピアノ販売数　{{ ranking['now_sell_num'] }}台</p>
																					<p class="card-text mb-3">過去に販売したピアノ台数　{{ ranking['sell_num'] }}台</p>
																				</div>
																				<hr>
																				<div>
																					<p><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></p>
																					<p>
																						<span v-if="ranking['about_return']==1">返品可能</span>
																						<span v-if="ranking['about_return']==2">返品不可</span>
																						<span v-if="ranking['about_exchange']==1">　交換可能</span>
																						<span v-if="ranking['about_exchange']==2">　交換不可</span>
																						<span v-if="ranking['whether_pay_installments']==1">　分割払い可能</span>
																						<span v-if="ranking['whether_pay_installments']==2">　分割払い不可</span>
																					</p>
																				</div>
																			</div>
																		</div>
																	</div>
																</a>
															<div class="col-md-2"></div>
														</div>
													</template>
												  </template>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetYunyuRankings">
													<template v-if="index==1||index==2||index==3">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<img v-if="index==1" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran2_mini.png">
															<img v-if="index==2" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran3_mini.png">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetYunyuRankings">
													<template v-if="index==4||index==5||index==6">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetYunyuRankings">
													<template v-if="index==7||index==8||index==9">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												</div>

												<!-- アップライトピアノ販売 -->
												<div class="" v-show="display == 4">

										          <template v-for="(ranking, index) in allGetUpRankings">
													<template v-if="index==0">
														<div class="row mt-5 mx-0">
															<div class="col-md-2"></div>
																<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="card col-md-8 pl-0 pr-0 m-0 my-3" style="color: #676460;">
																	<img class="" style="z-index: 1;position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran1_mini.png">
																	<div class="card-body row p-2">
																		<div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
																			<img class="" :src="ranking['image1']" style="width: 80%;height: auto;">
																		</div>
																		<div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
																			<div class="card-body">
																				<div style="position: relative;">
																					<div class="d-flex">
																						<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																						<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																						<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																					</div>
																					<p class="card-text mb-3">{{ ranking['slogan'] }}</p>
																					<p class="card-text mb-3">現在のピアノ販売数　{{ ranking['now_sell_num'] }}台</p>
																					<p class="card-text mb-3">過去に販売したピアノ台数　{{ ranking['sell_num'] }}台</p>
																				</div>
																				<hr>
																				<div>
																					<p><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></p>
																					<p>
																						<span v-if="ranking['about_return']==1">返品可能</span>
																						<span v-if="ranking['about_return']==2">返品不可</span>
																						<span v-if="ranking['about_exchange']==1">　交換可能</span>
																						<span v-if="ranking['about_exchange']==2">　交換不可</span>
																						<span v-if="ranking['whether_pay_installments']==1">　分割払い可能</span>
																						<span v-if="ranking['whether_pay_installments']==2">　分割払い不可</span>
																					</p>
																				</div>
																			</div>
																		</div>
																	</div>
																</a>
															<div class="col-md-2"></div>
														</div>
													</template>
												  </template>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetUpRankings">
													<template v-if="index==1||index==2||index==3">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<img v-if="index==1" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran2_mini.png">
															<img v-if="index==2" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran3_mini.png">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetUpRankings">
													<template v-if="index==4||index==5||index==6">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetUpRankings">
													<template v-if="index==7||index==8||index==9">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												</div>

												<!-- グランドピアノ販売 -->
												<div class="" v-show="display == 5">

										          <template v-for="(ranking, index) in allGetGrandRankings">
													<template v-if="index==0">
														<div class="row mt-5 mx-0">
															<div class="col-md-2"></div>
																<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="card col-md-8 pl-0 pr-0 m-0 my-3" style="color: #676460;">
																	<img class="" style="z-index: 1;position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran1_mini.png">
																	<div class="card-body row p-2">
																		<div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
																			<img class="" :src="ranking['image1']" style="width: 80%;height: auto;">
																		</div>
																		<div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
																			<div class="card-body">
																				<div style="position: relative;">
																					<div class="d-flex">
																						<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																						<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																						<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																					</div>
																					<p class="card-text mb-3">{{ ranking['slogan'] }}</p>
																					<p class="card-text mb-3">現在のピアノ販売数　{{ ranking['now_sell_num'] }}台</p>
																					<p class="card-text mb-3">過去に販売したピアノ台数　{{ ranking['sell_num'] }}台</p>
																				</div>
																				<hr>
																				<div>
																					<p><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></p>
																					<p>
																						<span v-if="ranking['about_return']==1">返品可能</span>
																						<span v-if="ranking['about_return']==2">返品不可</span>
																						<span v-if="ranking['about_exchange']==1">　交換可能</span>
																						<span v-if="ranking['about_exchange']==2">　交換不可</span>
																						<span v-if="ranking['whether_pay_installments']==1">　分割払い可能</span>
																						<span v-if="ranking['whether_pay_installments']==2">　分割払い不可</span>
																					</p>
																				</div>
																			</div>
																		</div>
																	</div>
																</a>
															<div class="col-md-2"></div>
														</div>
													</template>
												  </template>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetGrandRankings">
													<template v-if="index==1||index==2||index==3">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<img v-if="index==1" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran2_mini.png">
															<img v-if="index==2" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran3_mini.png">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetGrandRankings">
													<template v-if="index==4||index==5||index==6">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetGrandRankings">
													<template v-if="index==7||index==8||index==9">
														<a @click="jumpSeller(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2" v-if="ranking['legal_person']==1">{{ ranking['corp_name'] }}</strong>
																			<strong class="mr-2" v-if="ranking['legal_person']==0">{{ ranking['store_name'] }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong>{{ ranking['region'] + ': ' + ranking['address_1'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												</div>

											</div>
										</div>
										<div class="row tab_contents" v-else-if="type==2">
											<div class="col-md-12">

												<!-- 総合ピアノ販売 -->
												<div class="" v-show="display == 1">

										          <template v-for="(ranking, index) in allGetTotalRankings">
													<template v-if="index==0">
														<div class="row mt-5 mx-0">
															<div class="col-md-2"></div>
																<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="card col-md-8 pl-0 pr-0 m-0 my-3" style="color: #676460;">
																	<img class="" style="z-index: 1;position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran1_mini.png">
																	<div class="card-body row p-2">
																		<div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
																			<img class="" :src="ranking['image1']" style="width: 80%;height: auto;">
																		</div>
																		<div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
																			<div class="card-body">
																				<div style="position: relative;">
																					<div>
																						<div>
																							<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																							<strong class="mr-2">{{ ranking['model_number'] }}</strong>
																						</div>
																						<div class="d-flex">
																							<span class="mr-2">評価</span>
																							<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																						</div>
																					</div>
																					<p class="card-text mt-3" style="color: red;">平均購入価格（税抜） <strong>{{ ranking['price'] }}</strong> 円</p>
																					<p class="card-text mt-3">購入された台数 {{ ranking['sell_num'] }} 台</p>
																				</div>
																				<hr>
																				<div>
																					<p class="card-text mt-3">タイプ {{ get_hash_value(type_arr, ranking['type']) }}</p>
													                                <button @click="jumpSearch(1, ranking)" style="position: absolute;bottom: 15px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																				</div>
																			</div>
																		</div>
																	</div>
																</a>
															<div class="col-md-2"></div>
														</div>
													</template>
												  </template>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetTotalRankings">
													<template v-if="index==1||index==2||index==3">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<img v-if="index==1" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran2_mini.png">
															<img v-if="index==2" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran3_mini.png">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(1, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetTotalRankings">
													<template v-if="index==4||index==5||index==6">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(1, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetTotalRankings">
													<template v-if="index==7||index==8||index==9">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(1, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												</div>
												
												<!-- 国産ピアノ販売 -->
												<div class="" v-show="display == 2">

										          <template v-for="(ranking, index) in allGetKokusanRankings">
													<template v-if="index==0">
														<div class="row mt-5 mx-0">
															<div class="col-md-2"></div>
																<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="card col-md-8 pl-0 pr-0 m-0 my-3" style="color: #676460;">
																	<img class="" style="z-index: 1;position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran1_mini.png">
																	<div class="card-body row p-2">
																		<div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
																			<img class="" :src="ranking['image1']" style="width: 80%;height: auto;">
																		</div>
																		<div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
																			<div class="card-body">
																				<div style="position: relative;">
																					<div>
																						<div>
																							<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																							<strong class="mr-2">{{ ranking['model_number'] }}</strong>
																						</div>
																						<div class="d-flex">
																							<span class="mr-2">評価</span>
																							<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																						</div>
																					</div>
																					<p class="card-text mt-3" style="color: red;">平均購入価格（税抜） <strong>{{ ranking['price'] }}</strong> 円</p>
																					<p class="card-text mt-3">購入された台数 {{ ranking['sell_num'] }} 台</p>
																				</div>
																				<hr>
																				<div>
																					<p class="card-text mt-3">タイプ {{ get_hash_value(type_arr, ranking['type']) }}</p>
													                                <button @click="jumpSearch(2, ranking)" style="position: absolute;bottom: 15px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																				</div>
																			</div>
																		</div>
																	</div>
																</a>
															<div class="col-md-2"></div>
														</div>
													</template>
												  </template>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetKokusanRankings">
													<template v-if="index==1||index==2||index==3">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<img v-if="index==1" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran2_mini.png">
															<img v-if="index==2" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran3_mini.png">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(2, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetKokusanRankings">
													<template v-if="index==4||index==5||index==6">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(2, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetKokusanRankings">
													<template v-if="index==7||index==8||index==9">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(2, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												</div>

												<!-- 輸入ピアノ販売 -->
												<div class="" v-show="display == 3">

										          <template v-for="(ranking, index) in allGetYunyuRankings">
													<template v-if="index==0">
														<div class="row mt-5 mx-0">
															<div class="col-md-2"></div>
																<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="card col-md-8 pl-0 pr-0 m-0 my-3" style="color: #676460;">
																	<img class="" style="z-index: 1;position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran1_mini.png">
																	<div class="card-body row p-2">
																		<div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
																			<img class="" :src="ranking['image1']" style="width: 80%;height: auto;">
																		</div>
																		<div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
																			<div class="card-body">
																				<div style="position: relative;">
																					<div>
																						<div>
																							<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																							<strong class="mr-2">{{ ranking['model_number'] }}</strong>
																						</div>
																						<div class="d-flex">
																							<span class="mr-2">評価</span>
																							<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																						</div>
																					</div>
																					<p class="card-text mt-3" style="color: red;">平均購入価格（税抜） <strong>{{ ranking['price'] }}</strong> 円</p>
																					<p class="card-text mt-3">購入された台数 {{ ranking['sell_num'] }} 台</p>
																				</div>
																				<hr>
																				<div>
																					<p class="card-text mt-3">タイプ {{ get_hash_value(type_arr, ranking['type']) }}</p>
													                                <button @click="jumpSearch(3, ranking)" style="position: absolute;bottom: 15px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																				</div>
																			</div>
																		</div>
																	</div>
																</a>
															<div class="col-md-2"></div>
														</div>
													</template>
												  </template>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetYunyuRankings">
													<template v-if="index==1||index==2||index==3">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<img v-if="index==1" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran2_mini.png">
															<img v-if="index==2" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran3_mini.png">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(3, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetYunyuRankings">
													<template v-if="index==4||index==5||index==6">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(3, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetYunyuRankings">
													<template v-if="index==7||index==8||index==9">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(3, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												</div>

												<!-- アップライトピアノ販売 -->
												<div class="" v-show="display == 4">

										          <template v-for="(ranking, index) in allGetUpRankings">
													<template v-if="index==0">
														<div class="row mt-5 mx-0">
															<div class="col-md-2"></div>
																<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="card col-md-8 pl-0 pr-0 m-0 my-3" style="color: #676460;">
																	<img class="" style="z-index: 1;position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran1_mini.png">
																	<div class="card-body row p-2">
																		<div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
																			<img class="" :src="ranking['image1']" style="width: 80%;height: auto;">
																		</div>
																		<div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
																			<div class="card-body">
																				<div style="position: relative;">
																					<div>
																						<div>
																							<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																							<strong class="mr-2">{{ ranking['model_number'] }}</strong>
																						</div>
																						<div class="d-flex">
																							<span class="mr-2">評価</span>
																							<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																						</div>
																					</div>
																					<p class="card-text mt-3" style="color: red;">平均購入価格（税抜） <strong>{{ ranking['price'] }}</strong> 円</p>
																					<p class="card-text mt-3">購入された台数 {{ ranking['sell_num'] }} 台</p>
																				</div>
																				<hr>
																				<div>
																					<p class="card-text mt-3">タイプ {{ get_hash_value(type_arr, ranking['type']) }}</p>
													                                <button @click="jumpSearch(4, ranking)" style="position: absolute;bottom: 15px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																				</div>
																			</div>
																		</div>
																	</div>
																</a>
															<div class="col-md-2"></div>
														</div>
													</template>
												  </template>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetUpRankings">
													<template v-if="index==1||index==2||index==3">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<img v-if="index==1" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran2_mini.png">
															<img v-if="index==2" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran3_mini.png">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(4, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetUpRankings">
													<template v-if="index==4||index==5||index==6">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(4, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetUpRankings">
													<template v-if="index==7||index==8||index==9">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(4, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												</div>

												<!-- グランドピアノ販売 -->
												<div class="" v-show="display == 5">

										          <template v-for="(ranking, index) in allGetGrandRankings">
													<template v-if="index==0">
														<div class="row mt-5 mx-0">
															<div class="col-md-2"></div>
																<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="card col-md-8 pl-0 pr-0 m-0 my-3" style="color: #676460;">
																	<img class="" style="z-index: 1;position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran1_mini.png">
																	<div class="card-body row p-2">
																		<div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
																			<img class="" :src="ranking['image1']" style="width: 80%;height: auto;">
																		</div>
																		<div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
																			<div class="card-body">
																				<div style="position: relative;">
																					<div>
																						<div>
																							<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																							<strong class="mr-2">{{ ranking['model_number'] }}</strong>
																						</div>
																						<div class="d-flex">
																							<span class="mr-2">評価</span>
																							<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																						</div>
																					</div>
																					<p class="card-text mt-3" style="color: red;">平均購入価格（税抜） <strong>{{ ranking['price'] }}</strong> 円</p>
																					<p class="card-text mt-3">購入された台数 {{ ranking['sell_num'] }} 台</p>
																				</div>
																				<hr>
																				<div>
																					<p class="card-text mt-3">タイプ {{ get_hash_value(type_arr, ranking['type']) }}</p>
													                                <button @click="jumpSearch(5, ranking)" style="position: absolute;bottom: 15px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																				</div>
																			</div>
																		</div>
																	</div>
																</a>
															<div class="col-md-2"></div>
														</div>
													</template>
												  </template>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetGrandRankings">
													<template v-if="index==1||index==2||index==3">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<img v-if="index==1" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran2_mini.png">
															<img v-if="index==2" class="" style="position: absolute;top: -10px;left: -10px;" src="/static/img/icon/ran3_mini.png">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(5, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetGrandRankings">
													<template v-if="index==4||index==5||index==6">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(5, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												  <div class="row">
										          <template v-for="(ranking, index) in allGetGrandRankings">
													<template v-if="index==7||index==8||index==9">
														<a @click="jumpProductDetail(ranking['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
															<div class="card p-3">
															<div class="text-center center-block" style="min-height: 160px;max-height: 160px;">
																<img class="card-img-best" :src="ranking['image1']" alt="">
															</div>
															<div class="card-body p-0 pt-2">
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span>
																			<strong class="mr-2">{{ get_hash_value(brand, ranking['brand']) }}</strong>
																		</span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 ellipsis_text" style="max-width: 240px;">
																		<span><strong class="mr-2">{{ ranking['model_number'] }}</strong></span>
																	</div>
																</div>
																<hr class="m-0">
																<div class="row my-1">
																	<div class="col-md-12 d-flex">
																		<span class="pt-1 mr-2">評価</span>
																		<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="ranking['evaluation']"></star-rating>
																	</div>
																	<button @click="jumpSearch(5, ranking)" style="position: absolute;bottom: 6px;right: 20px;width: 80px;" class="btn btn-primary">一覧へ</button>
																</div>
															</div>
															</div>
														</a>
													</template>
												  </template>
												  </div>

												</div>

											</div>
										</div>
									</div>
								</div>

							</div>
						</div>

					</div>

				</div>
			</div>

		</b-container>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import StarRating from 'vue-star-rating'

export default {
	name: 'Ranking',
    components: {
	  'star-rating': StarRating,
    },
	data () {
		const type_arr = [
			{"no":"0","name":"未選択"},
			{"no":"1","name":"グランドピアノ（GP）"},
			{"no":"2","name":"アップライトピアノ（UP）"},
	    ];
		const brand = [
		    {"no":"0","name":"未選択"},
			{"no":"1","name":"ヤマハ（YAMAHA）"},
			{"no":"2","name":"カワイ（KAWAI）"},
			{"no":"3","name":"スタインウェイ・アンド・サンズ　（Steinway&Sons）"},
			{"no":"4","name":"ベーゼンドルファー　（Bösendorfer）"},
			{"no":"5","name":"ベヒシュタイン　（BECHSTEIN）"},
			{"no":"6","name":"ボストン　（BOSTON）"},
			{"no":"7","name":"ディアパソン　（DIAPASON）"},
			{"no":"8","name":"アポロ　（APOLLO）"},
			{"no":"9","name":"国産ピアノ"},
			{"no":"10","name":"輸入ピアノ"},
	    ];
		return {
			type_arr,
			brand,

			type: 1, // 1:販売 2:ピアノ
			display: 1,
			ranking_name: "",

            total_rankings: [],
            kokusan_rankings: [],
            yunyu_rankings: [],
            up_rankings: [],
            grand_rankings: [],
		}
	},
	methods: {
	  jumpSearch(type, ranking) {
		if (type==1) { // 総合
	      this.$router.push({path: '/search', query: {main_search_type: 1, search_word: ranking['model_number'], search_brand: ranking['brand'], search_type: ranking['type']}});
		} else if (type==2) { // 国産
	      this.$router.push({path: '/search', query: {main_search_type: 1, search_word: ranking['model_number'], search_brand: ranking['brand'], search_type: ranking['type']}});
		} else if (type==3) { // 輸入
	      this.$router.push({path: '/search', query: {main_search_type: 1, search_word: ranking['model_number'], search_brand: ranking['brand'], search_type: ranking['type']}});
		} else if (type==4) { // アップライト
	      this.$router.push({path: '/search', query: {main_search_type: 1, search_word: ranking['model_number'], search_brand: ranking['brand'], search_type: ranking['type']}});
		} else if (type==5) { // グランド
	      this.$router.push({path: '/search', query: {main_search_type: 1, search_word: ranking['model_number'], search_brand: ranking['brand'], search_type: ranking['type']}});
		}
		return false;
	  },
	  changeDisplay(num) {
		this.display = num;
		if ( String(this.type) == '1' ) {
		  if ( this.display == 1 ) {
			this.ranking_name = "総合ピアノ販売者";
		  } else if ( this.display == 2 ) {
			this.ranking_name = "国産ピアノ販売者";
		  } else if ( this.display == 3 ) {
			this.ranking_name = "輸入ピアノ販売者";
		  } else if ( this.display == 4 ) {
			this.ranking_name = "アップライトピアノ販売者";
		  } else if ( this.display == 5 ) {
			this.ranking_name = "グランドピアノ販売者";
		  }
		} else {
		  if ( this.display == 1 ) {
			this.ranking_name = "総合ピアノ";
		  } else if ( this.display == 2 ) {
			this.ranking_name = "国産ピアノ";
		  } else if ( this.display == 3 ) {
			this.ranking_name = "輸入ピアノ";
		  } else if ( this.display == 4 ) {
			this.ranking_name = "アップライトピアノ";
		  } else if ( this.display == 5 ) {
			this.ranking_name = "グランドピアノ";
		  }
		}
	  },
	  jumpSeller(id) {
        this.$router.push({path: '/seller/'+String(id)});
	  },
      jumpProductDetail: function(id){
		return false;
        // this.$router.push({path: '/product/'+String(id)});
	  },
	  async get_ranking() {
		this.$store.dispatch('product/get_ranking', {
          type: this.type,
        }).then(res => {
		  console.log(res);
		  let ret = res.data;
		  if ( String(this.type) == '1' ) {
			this.ranking_name = "総合ピアノ販売者";
			this.total_rankings = ret['total_rankings'];
			this.kokusan_rankings = ret['kokusan_rankings'];
			this.yunyu_rankings = ret['yunyu_rankings'];
			this.up_rankings = ret['up_rankings'];
			this.grand_rankings = ret['grand_rankings'];
		  } else if ( String(this.type) == '2' ) {
			this.ranking_name = "総合ピアノ";
			this.total_rankings = ret['total_rankings'];
			this.kokusan_rankings = ret['kokusan_rankings'];
			this.yunyu_rankings = ret['yunyu_rankings'];
			this.up_rankings = ret['up_rankings'];
			this.grand_rankings = ret['grand_rankings'];
		  }
		}, error => {
		  console.log('error発生');
		  console.log(error);
		  this.$nextTick(() => {
            window.scrollTo({
              top: 0,
            });
		  });
	    });
	  },
	},
	created() {
		this.type = this.$route.query.type;
		this.get_ranking();
	},
	computed: {
		allGetTotalRankings: function() {
			return this.total_rankings;
		},
		allGetKokusanRankings: function() {
			return this.kokusan_rankings;
		},
		allGetYunyuRankings: function() {
			return this.yunyu_rankings;
		},
		allGetUpRankings: function() {
			return this.up_rankings;
		},
		allGetGrandRankings: function() {
			return this.grand_rankings;
		},
	},
}
</script>

<style scoped>
.vue-star-rating {
	justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Ranking.vue